<!--
	THIS BASKET IS THE SELECTED ARTICLES IN THE PICTURE WALL APP
-->

<template>
	<div v-bind:class="{ basket: true, flipToggle: true, active: active }">
		<div v-if="!hasPictureWall" class="title tiny-heading">
			{{ $t("needsPictureWall") }}
		</div>
		<div v-if="hasPictureWall" class="title tiny-heading">
			{{ $t("clickToPickMotif") }}
		</div>

		<div v-if="hasArticles" class="chosenArticles">
			<div
				class="article"
				v-if="article"
				v-for="(article, index) in articles"
				:key="index"
			>
				<div class="left">
					<div class="image">
						<div class="inner">
							<img
								:src="getArticleImage(article)"
							/>
						</div>
						<!-- inner -->
					</div>
					<!-- image -->
				</div>
				<!-- left -->

				<div class="right">
					<div class="name ellipsis">{{ article.title }}</div>
					<div class="price">

						<div :class="{ originalPrice: true, oldPrice: article.campaignPrice }">
							<span v-html="$t('currencyPrefix')"></span>
								{{ article.price }}
							<span v-html="$t('currencySuffix')"></span>
						</div>

						<div v-if="article.campaignPrice" :class="{ newPrice: true }">
							<span v-html="$t('currencyPrefix')"></span>
								{{ article.campaignPrice }}
							<span v-html="$t('currencySuffix')"></span>
						</div>

					</div>
					<div v-on:click="removeProduct(index)" class="action">
						<i class="fa fa-trash"></i>
					</div>
				</div>
				<!-- right -->
			</div>
			<!-- article -->
		</div>
		<!-- chosenArticles -->
	</div>
	<!-- articlePicker -->
</template>

<script>
require("lodash")

export default {

	data: function(){
		return{
			loading: false,
			imageUrl: this.getCdn()
		}
	},

	computed: {
		hasPictureWall(){
			return this.$store.state.pictureWall != false;
		},

		hasArticles(){
			var passed = false;

			 if(!jQuery.isEmptyObject(this.$store.state.chosenArticles)){
			 	$.each(this.$store.state.chosenArticles, function(index, value){
			 		if(value)
			 			passed = true
			 	})
			 }

			 return passed
		},

		articles(){
			return this.$store.state.chosenArticles
		},

		active(){
			return this.$store.state.currentPicker == 'basket'
		},

	},

	methods: {

		getArticleUrl(article){
			return "/shop?funk=visa_artikel&artnr=" + article.parent
		},

		removeProduct(index){
			var articles = this.$store.state.chosenArticles;
			articles[index] = false;
			this.$store.commit('chosenArticles', articles);
			this.checkHighlight()
		},

		close: function(){
		  this.resetPickerData()
		  this.$store.commit('highlightPictureWallItems', false);
		},

		checkHighlight(){
			if(this.hasPictureWall && !this.hasArticles)
				this.$store.commit('highlightPictureWallItems', true);
		}

	},

	created: function () {

		var self = this;

		// When opening the basket
		window.eventHub.$on('openBasket', function () {

			// Close if open to reload data
			self.close();

			// Close other pickers
			self.closePickers('basket')

			// Highlight articles if needed
			self.checkHighlight()

			// Open
		  	self.$store.commit('currentPicker', 'basket')
			self.$store.commit('leftTitle', self.$t('yourMotifs'))

		});

		// Close picker event also closes basket as it is positioned at the same place
		window.eventHub.$on('closePickers', function (type) {
			if(type != 'basket'){
				self.close();
			}
		});

	}
}
</script>

<style lang="scss">
	.basket {
		width: 100%;
		height: 100%;
		overflow: auto;

		&.flipToggle.active {
			top: 75px;
			height: calc(100% - 75px);

			@media screen and (max-width: 844px) {
				top: 15px;
				height: calc(100% - 15px);
			}
		}

		.title {
			margin: 10px auto 10px auto;
			text-align: center;
			max-width: 266px;
			line-height: 23px;
			text-transform: uppercase;
			color: #8b8b8b;
			padding: 10px;
			font-size: 13px;

			/* Mobile */
			@media screen and (max-width: 813px) {
				font-size: 11px;
			}
		}

		.chosenArticles {
			padding: 15px;
			height: 100%;
		}

		.article {
			float: left;
			width: 100%;
			position: relative;
			margin-bottom: 10px;

			.left {
				float: left;
				width: 25%;
			}

			.right {
				float: left;
				width: 74.9%;
				padding: 0px 14px;

				/* Mobile */
				@media screen and (max-width: 813px) {
					padding: 0px 5px;
				}
			}

			.image {
				/* Mobile */
				@media screen and (max-width: 813px) {
					min-height: 42px;
					display: table;

					.inner {
						display: table-cell;
						vertical-align: middle;
					}
				}
			}

			.name {
				font-size: 12px;
				font-weight: 500;
				text-transform: uppercase;
				font-family: "Raleway", "Helvetica Neue", "Helvetica", Arial, sans-serif;
				width: 80%;

				/* Mobile */
				@media screen and (max-width: 813px) {
					display: none;
				}
			}

			.price {
				margin-top: 5px;
				font-weight: 500;
				font-size: 15px;

				/* Mobile */
				@media screen and (max-width: 813px) {
					font-size: 11px;
					margin-top: 10px;
				}
			}

			.originalPrice{
				float: left;
				margin-right: 15px;
			}

			.oldPrice{
				color: grey;
				font-weight: 400;
				text-decoration: line-through;
			}

			.action {
				padding: 10px;
				position: absolute;
				right: 0;
				top: 50%;
				margin-top: -22.5px;
				margin-right: 12px;
				cursor: pointer;

				/* Mobile */
				@media screen and (max-width: 813px) {
					margin-right: 0;
					margin-top: -25px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Basket.vue?99e09a42